/** @jsxImportSource solid-js */
import { render } from "solid-js/web";
import { WidgetProvider } from "../hooks/widget-context";
import { type WidgetStore } from "../store/widget-store";
import { WidgetRoot } from "./widget-root";

export function mountWidgetRoot(container: HTMLElement, store: WidgetStore): () => void {
  return render(
    () => (
      <WidgetProvider store={store}>
        <WidgetRoot />
      </WidgetProvider>
    ),
    container,
  );
}
